export { default as Fade } from './Fade';



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/transitions/index.ts